export default "__VITE_ASSET__trJlX6ua__"